export default [
    {
      path: "/clientlist",
      name: "clientlist",
      component: () => import(/* webpackChunkName: "admin" */ "../views/admin/vClientList.vue"),
      meta: { title: "Client List", auth: true, roles: [20] },
    },
  ];
  